<div class="bottom-sheet-overlay" (click)="closeBottomSheet()">
  <div class="bottom-sheet-content" (click)="onContentClick($event)">
    <ng-content></ng-content>
  </div>
</div>
